export const MINUTE_STEPS = [0, 15, 30, 45];

export const MINUTES_IN_DAY = 1440;

export const LAST_SLOT = MINUTES_IN_DAY - 15;
